// IMPORTANT: Keep this in sync with the section group definitions in permissionsCellTemplates.pug

import { capabilities, capabilitiesByRole, CapabilityInfo } from './Capabilities';

export interface Section {
  locKey: string;
  capabilities: ReadonlyArray<CapabilityInfo>;
}

export interface SectionGroup {
  name: string;
  locKey: string;
  sections: ReadonlyArray<Section>;
}

function getDatabaseSections() {
  return [
    { locKey: 'viewAndEdit', capabilities: [capabilities.read, capabilities.write, capabilities.changePermissions] },
  ];
}

export function getDatasourceSections(): ReadonlyArray<Section> {
  return [
    { locKey: 'use', capabilities: [capabilities.read, capabilities.connect] },
    { locKey: 'edit', capabilities: [capabilities.write, capabilities.exportXmlDatasource, capabilities.delete, capabilities.changePermissions] },
  ];
}

export function getFlowSections(): ReadonlyArray<Section> {
  return [
    { locKey: 'permissions_header_run',  capabilities: [capabilities.read, capabilities.executeFlow] },
    { locKey: 'edit', capabilities: [capabilities.write, capabilities.exportXmlFlow, capabilities.changeHierarchy, capabilities.delete, capabilities.changePermissions] },
  ];
}

export function getDataRoleSections(): ReadonlyArray<Section> {
  return [
    { locKey: 'viewAndEdit', capabilities: [capabilities.read, capabilities.write, capabilities.changeHierarchy, capabilities.delete, capabilities.changePermissions] },
  ];
}

export function getTableSections() {
  return [
    { locKey: 'viewAndEdit', capabilities: [capabilities.read, capabilities.write, capabilities.changePermissions] },
  ];
}

export function getViewSections(): ReadonlyArray<Section> {
  return [
    { locKey: 'view',     capabilities: capabilitiesByRole.viewer },
    { locKey: 'interact', capabilities: capabilitiesByRole.interactor },
    { locKey: 'edit',     capabilities: [capabilities.delete, capabilities.changePermissions] },
  ];
}

export function getWorkbookSections(): ReadonlyArray<Section> {
  return [
    { locKey: 'permissions_header_view',     capabilities: capabilitiesByRole.viewer },
    { locKey: 'interact', capabilities: capabilitiesByRole.interactor },
    { locKey: 'edit',     capabilities: [capabilities.write, capabilities.exportXmlWorkbook, capabilities.changeHierarchy, capabilities.delete, capabilities.changePermissions] },
  ];
}

export function getProjectSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'project', locKey: 'project', sections: [{ locKey: 'details', capabilities: [capabilities.read, capabilities.write, capabilities.projectLeader]} ]},
    { name: 'projectWorkbookTemplate', locKey: 'workbooks', sections: getWorkbookSections() },
    { name: 'projectDatasourceTemplate', locKey: 'datasources', sections: getDatasourceSections() },
  ];
}

export function getProjectSectionGroupsWithFlowsAndDataRoles(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'project', locKey: 'project', sections: [{ locKey: 'details', capabilities: [capabilities.read, capabilities.write, capabilities.projectLeader]} ]},
    { name: 'projectWorkbookTemplate', locKey: 'workbooks', sections: getWorkbookSections() },
    { name: 'projectDatasourceTemplate', locKey: 'datasources', sections: getDatasourceSections() },
    { name: 'projectFlowTemplate', locKey: 'flows', sections: getFlowSections() },
    { name: 'projectDataRoleTemplate', locKey: 'dataRoles', sections: getDataRoleSections() },
  ];
}

export function getDatasourceSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'datasource', locKey: 'permissions', sections: getDatasourceSections() },
  ];
}

export function getFlowSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'flow', locKey: 'permissions', sections: getFlowSections() },
  ];
}

export function getDataRoleSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'dataRole', locKey: 'permissions', sections: getDataRoleSections() },
  ];
}

export function getViewSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'view', locKey: 'permissions', sections: getViewSections() },
  ];
}

export function getWorkbookSectionGroups(): ReadonlyArray<SectionGroup> {
  return [
    { name: 'workbook', locKey: 'permissions', sections: getWorkbookSections() },
  ];
}

export function getDatabaseSectionGroups() {
    return [
        { name: 'database', locKey: 'database', sections: getDatabaseSections() },
        { name: 'databaseTableTemplate', locKey: 'tables', sections: getTableSections() },
    ];
}

export function getTableSectionGroups() {
    return [
        { name: 'table', locKey: 'permissions', sections: getTableSections() },
    ];
}
